import AccountStatement from "./AccountStatement";

export default AccountStatement;